import React from "react";
import { motion } from "framer-motion";
import { ASSETS } from "../../data/landing";
import { useLanguage } from "../../i18n/LanguageContext";
import StoreButtons from "./StoreButtons";

export const DownloadCTA = () => {
  const { t } = useLanguage();
  const c = t.finalCta;

  return (
    <section
      id="download"
      className="relative px-6 pb-24 md:px-12 md:pb-32"
      data-testid="download-section"
    >
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        className="relative mx-auto max-w-6xl overflow-hidden rounded-[2.5rem] bg-[#7B1113] px-8 py-16 text-center md:px-16 md:py-24"
      >
        <div className="pointer-events-none absolute -top-20 left-1/2 h-[300px] w-[300px] -translate-x-1/2 rounded-full bg-[#F5A623]/25 blur-[100px]" />
        <div className="pointer-events-none absolute -bottom-24 -right-16 h-[260px] w-[260px] rounded-full bg-[#F5A623]/15 blur-[90px]" />

        <div className="relative flex flex-col items-center">
          <motion.img
            src={ASSETS.logo}
            alt={t.brand}
            width="64"
            height="64"
            animate={{ y: [-6, 6, -6] }}
            transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
            className="mb-8 h-16 w-16 rounded-full object-cover shadow-[0_10px_30px_-8px_rgba(0,0,0,0.4)]"
          />
          <h2 className="max-w-2xl text-3xl font-semibold leading-tight tracking-tight text-[#FCFAF7] md:text-4xl lg:text-5xl">
            {c.heading}
          </h2>
          <p className="mt-5 max-w-xl text-base leading-relaxed text-[#FCFAF7]/75 md:text-lg">
            {c.subtitle}
          </p>
          <div className="mt-9 rounded-2xl bg-[#FCFAF7]/8 p-3 backdrop-blur-sm">
            <StoreButtons align="center" testidPrefix="download" size="lg" />
          </div>
        </div>
      </motion.div>
    </section>
  );
};

export default DownloadCTA;
